import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const includes = ['Los 6 Tomos Digitales', 'El Árbol Inteligente de Decisiones', 'Los 5 Bonos Exclusivos', 'Más de 300 páginas listas para usar', 'Acceso de por vida', 'Garantía de 7 días'];
export function FinalCta() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-93" data-mp="15bsnljbdccl5">
      <div className="mx-auto max-w-2xl text-center" data-id="element-94" data-mp="1jcv83rmptety">
        <h2 className="font-display text-2xl font-black leading-tight text-plum-deep sm:text-4xl" data-id="element-95" data-mp="1jbahue7foi1w">
          ¿Lista para dejar de buscar…{' '}
          <span className="text-mauve" data-id="element-96" data-mp="1t2ojosmuxty7">
            y volver a disfrutar el tejido?
          </span>
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-plum/75" data-id="element-97" data-mp="1o3len86vnnq8">
          Cada día que pasa ocurre exactamente lo mismo. Guardas otro patrón.
          Compras otra lana. Prometes que mañana empezarás. Pero mañana vuelves
          a preguntarte: <em className="font-semibold text-plum" data-id="element-98" data-mp="1x6ct7gv1uzm3">”¿Qué podría tejer hoy?”</em>
        </p>
        <p className="mt-4 font-display text-lg font-bold text-plum" data-id="element-99" data-mp="n75ovzgcwr6t">
          No necesitas más inspiración. Necesitas un sistema que tome esa
          decisión contigo.
        </p>

        <div className="mx-auto mt-8 max-w-md rounded-2xl bg-white p-6 shadow-lg ring-1 ring-mauve-soft/40" data-id="element-100" data-mp="x2z821okzixk">
          <p className="text-sm font-bold text-plum" data-id="element-101" data-mp="124g8xx72f5e5">
            Hoy puedes obtener acceso completo a:
          </p>
          <ul className="mt-4 space-y-2.5 text-left" data-id="element-102" data-mp="162dy500u5rhj">
            {includes.map(it => <li key={it} className="flex items-center gap-3 text-sm font-medium text-plum/80" data-id="element-103" data-mp="1b1qldlvmd0kn">
                <CheckIcon className="h-5 w-5 flex-none text-sage" data-id="element-104" data-mp="1fv1rtlwirfc1" /> {it}
              </li>)}
          </ul>
          <p className="mt-6 text-sm text-plum/70" data-id="element-105" data-mp="1kv7c2h0glzk3">Todo por solo:</p>
          <p className="font-display text-5xl font-black text-plum-deep sm:text-6xl" data-id="element-106" data-mp="1pu0u8mqoyeql">
            USD $12.99
          </p>
          <div className="mt-6" data-id="element-107" data-mp="1tryedb5luan4">
            <CtaButton data-id="element-108" data-mp="3qu5qk9ywzrq5" />
            <p className="mt-3 text-xs font-semibold text-plum/70" data-id="element-109" data-mp="3qvgse48supem">
              Descarga inmediata · Pago único · Acceso de por vida · Garantía de
              7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}